import React from 'react';
import { Link } from 'react-router-dom';
import Div from '../Div';
import { formatServiceSlug } from '../../helper';

function formatBreadcrumbText(text) {
  if (!text) return '';
  if (/^[a-z0-9-]+$/.test(text)) {
    return formatServiceSlug(text);
  }
  return text;
}

export default function PageHeading({ title, bgSrc, pageLinkText }) {
  const breadcrumbLabel = formatBreadcrumbText(pageLinkText);

  return (
    <Div
      className="cs-page_heading cs-style1 cs-center text-center cs-bg"
      style={{ backgroundImage: `url(${bgSrc})` }}
    >
      <Div className="container">
        <Div className="cs-page_heading_in">
          <h1 className="cs-page_title cs-font_50 cs-white_color">{title}</h1>
          <ol className="breadcrumb text-uppercase">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">{breadcrumbLabel}</li>
          </ol>
        </Div>
      </Div>
    </Div>
  );
}
